import { useLoginContext } from "../../../App";
import { enableDisableUserMembership, removeUserMembership } from "../../../services/b2b-users-apiService";
import useB2BTranslation from "../../b2b-common/hooks/useB2BTranslation";
import { showNotification } from "../../b2b-common/Notification";
import { useContentContext } from "../../layout/Layout";

const useMembershipManagement = ({ membership }) => {
    const { loginData } = useLoginContext();
    const { setNotification } = useContentContext();
    const { t } = useB2BTranslation('b2b-users');

    const enableDisableMembership = async () => {
        if (!membership) return;
        try {
            const userId = membership.userId;
            const organizationUUID = loginData.loggedOrganizationUuid;
            await enableDisableUserMembership(organizationUUID, userId, !membership.enabled, loginData.accessToken);
            if (membership.enabled) 
                showNotification(setNotification, t('Membership disabled successfully'), 'success', 3000);
            else
                showNotification(setNotification, t('Membership enabled successfully'), 'success', 3000);
        } catch (error) {
            console.error('Error enabling/disabling membership:', error);
            showNotification(setNotification, t('Error enabling/disabling membership'), 'error', 5000);
        }
    }

    const removeMembership = async () => {
        if (!membership) return;
        try {
            const userId = membership.userId;
            const organizationUUID = loginData.loggedOrganizationUuid;
            await removeUserMembership(organizationUUID, userId, loginData.accessToken);
            showNotification(setNotification, t('Membership permanently removed successfully'), 'success', 3000);
        } catch (error) {
            console.error('Error removing membership:', error);
            showNotification(setNotification, t('Error removing membership'), 'error', 5000);
        }
    }

    return { enableDisableMembership, removeMembership };
}

export default useMembershipManagement;